export class WorkType {
  constructor(public readonly id: string, public readonly name: string) {}
}
